import { render, staticRenderFns } from "./IconTraining.vue?vue&type=template&id=537c5e3e"
import script from "./IconTraining.vue?vue&type=script&lang=js"
export * from "./IconTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports